/*
 * Migration status values (Transition status).*/
// eslint-disable-next-line max-len
// See BE values https://dev.azure.com/tr-tax/TaxProf/_git/aafm-platform-migration-orchestrator?path=/src/main/java/com/tr/bluemoon/migrationorchestrator/constants/MigrationConstants.java
export enum MigrationStatus {
	ACCEPTED = 'ACCEPTED',
	INQUEUE = 'INQUEUE',
	IN_PROGRESS = 'INPROGRESS',
	PENDING_CONFLICTS = 'PENDINGCONFLICTS',
	COMPLETED = 'COMPLETED',
	CANCELLED = 'CANCELLED',
	ERROR = 'ERROR',
}
